import * as React from "react";
import type { SVGProps } from "react";
const SvgMastercard = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 932 596" width="1em" height="1em" {...props}><path d="M35.875 21.323h153.458c8.037 0 14.552 6.515 14.552 14.552v95.25c0 8.037-6.515 14.552-14.552 14.552H35.875c-8.037 0-14.552-6.515-14.552-14.553v-95.25c0-8.036 6.515-14.551 14.552-14.551Zm0 0" style={{
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "#d9d9d9",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    strokeWidth: "5.0817px"
  }} transform="matrix(4.9592 0 0 4.595 -92.43 -85.686)" /><path d="M406.305 395.39c-22.485 19.419-51.657 31.141-83.532 31.141-71.12 0-128.777-58.363-128.777-130.363s57.656-130.363 128.777-130.363c31.875 0 61.047 11.722 83.532 31.14 22.488-19.418 51.66-31.14 83.53-31.14 71.126 0 128.782 58.363 128.782 130.363s-57.656 130.363-128.781 130.363c-31.871 0-61.043-11.722-83.531-31.14Zm0 0" style={{
    stroke: "none",
    fillRule: "evenodd",
    fill: "#ed0006",
    fillOpacity: 1,
    strokeWidth: "18.1294px"
  }} transform="matrix(1.3906 0 0 1.2875 -92.43 -85.686)" /><path d="M406.305 395.39c27.691-23.91 45.246-59.492 45.246-99.222s-17.555-75.313-45.246-99.223c22.488-19.418 51.66-31.14 83.53-31.14 71.126 0 128.782 58.363 128.782 130.363s-57.656 130.363-128.781 130.363c-31.871 0-61.043-11.722-83.531-31.14Zm0 0" style={{
    stroke: "none",
    fillRule: "evenodd",
    fill: "#f9a000",
    fillOpacity: 1,
    strokeWidth: "18.1294px"
  }} transform="matrix(1.3906 0 0 1.2875 -92.43 -85.686)" /><path d="M406.305 395.39c27.691-23.91 45.246-59.492 45.246-99.222s-17.555-75.313-45.246-99.223c-27.688 23.91-45.246 59.493-45.246 99.223s17.558 75.312 45.246 99.223Zm0 0" style={{
    stroke: "none",
    fillRule: "evenodd",
    fill: "#ff5e00",
    fillOpacity: 1,
    strokeWidth: "18.1294px"
  }} transform="matrix(1.3906 0 0 1.2875 -92.43 -85.686)" /></svg>;
export default SvgMastercard;